import React from "react";

import { MutedDarkText } from "shared/styles";
import { CaretDown } from "shared/assets/icons";
import { StyledValue, StyledDropdownIndicator } from "../styles";
import { ISelectValue } from "../types";

export const CountryValue: React.FC<ISelectValue> = ({ value, isOpen }) => {
  const { label, prefix, iconComponent } = value;
  return (
    <StyledValue>
      {iconComponent}
      {prefix ? <MutedDarkText>{prefix}</MutedDarkText> : <span>{label}</span>}
      <StyledDropdownIndicator isOpen={isOpen}>
        <CaretDown />
      </StyledDropdownIndicator>
    </StyledValue>
  );
};
